import clsx from 'clsx';
import CurrencyInputField from 'react-currency-input-field';

export interface CurrencyInputProps {
  name: string;
  placeholder?: string;
  size?: 'sm' | 'md' | 'lg';
  error?: string;
  touched?: boolean;
  onChange?: (value: string) => void;
  prefix?: string;
  initialValue?: string;
  value?: string;
  onBlur?: () => void;
}

const CurrencyInput = ({
  name,
  placeholder,
  size,
  error,
  touched,
  onChange,
  prefix,
  initialValue,
  value,
  onBlur,
}: CurrencyInputProps) => {
  return (
    <CurrencyInputField
      key={`id_${name}_${prefix}`}
      id={`id_${name}`}
      name={String(name)}
      placeholder={placeholder}
      // defaultValue={form.initialValues[name]}
      decimalsLimit={2}
      className={clsx(
        `form-control form-control-${size}`,
        { 'is-invalid': touched && error },
        { 'is-valid': touched && error }
      )}
      onValueChange={(value, name) => {
        if (onChange) onChange(value!);
      }}
      onBlur={onBlur}
      prefix={prefix}
      defaultValue={initialValue ?? value}
    />
  );
};

export default CurrencyInput;
